/* eslint-disable prettier/prettier */
import { v4 as uuidV4 } from "uuid";

export const QUERY = {
  allCompanies: `
  query MyQuery {
    allCompanies(condition: {isActive: true}) {
      nodes {
        id
        value:id
        companyName
        label:companyName
        address
        city
        state
        country
        contactPerson
        contactPersonEmail
        contactPersonMobile
        contactPersonPosition
        createdBy
        updatedAt
      }
    }
  }
    `,
  addCompany: ({ companyName, address, city, state, country, contactPerson, contactPersonPosition, contactPersonEmail, contactPersonMobile }) => `
    mutation MyMutation {
      createCompany(
        input: {
          company: {
            id: "${uuidV4()}"
            companyName: "${companyName}"
            address: "${address}"
            city: "${city}"
            state: "${state}"
            country: "${country}"
            contactPerson: "${contactPerson}"
            contactPersonEmail: "${contactPersonEmail}"
            contactPersonMobile: "${contactPersonMobile}"
            contactPersonPosition: "${contactPersonPosition}"
            isActive: true
            createdAt: "${new Date().toISOString()}"
            updatedAt: "${new Date().toISOString()}"
          }
        }
      ){
        clientMutationId
      }
    }
    `,
  updateCompany: ({ id, isActive = true, companyName, address, city, state, country, contactPerson, contactPersonPosition, contactPersonEmail, contactPersonMobile }) => `
    mutation MyMutation {
      updateCompanyById(
        input: {
          companyPatch: {
            ${companyName ? `companyName: "${companyName}"` : ``}
            ${address ? `address: "${address}"` : ``}
            ${city ? `city: "${city}"` : ``}
            ${state ? `state: "${state}"` : ``}
            ${country ? `country: "${country}"` : ``}
            ${contactPerson ? `contactPerson: "${contactPerson}"` : ``}
            ${contactPersonEmail ? `contactPersonEmail: "${contactPersonEmail}"` : ``}
            ${contactPersonMobile ? `contactPersonMobile: "${contactPersonMobile}"` : ``}
            ${contactPersonPosition ? `contactPersonPosition: "${contactPersonPosition}"` : ``}
            isActive: ${isActive}
            updatedAt: "${new Date().toISOString()}"
          }
          id: "${id}"
        }
      ) {
        clientMutationId
      }
    }
    
    `
};